import { User } from "./types";

/**
 * Whether this account is an end consumer rather than a business customer.
 *
 * b2c accounts see a reduced library (combinations and the materials tagged for
 * end customers, no objects or light sources) and are capped at three scenes
 * per project.
 *
 * The single place the `b2b` default lives: `scope` is absent on accounts
 * created before the server had the field, and all of those are business
 * customers. Comparing `user.scope === "b2c"` inline would spread that
 * assumption across the codebase.
 */
const isB2cUser = (user?: User | null): boolean => (user?.scope ?? "b2b") === "b2c";

export default isB2cUser;
